import Vue from 'vue';
import {
    Button,
    Icon,
    Swipe,
    SwipeItem,
    Collapse,
    CollapseItem,
    Slider,
    PasswordInput,
    NumberKeyboard,
    PullRefresh,
    Loading,
    ImagePreview,
    Lazyload 
} from 'vant';

Vue.use(Button)
   .use(Icon)
   .use(Swipe)
   .use(SwipeItem)
   .use(Collapse)
   .use(CollapseItem)
   .use(Slider)
   .use(PasswordInput)
   .use(NumberKeyboard)
   .use(PullRefresh)
   .use(Loading)
   .use(ImagePreview)
   .use(Lazyload);
